import { useQuery } from '@tanstack/react-query'
import { endOfDay, format, startOfDay } from 'date-fns'
import { supabase } from '../../api'

type EventType = {
  name: string,
  date: Date,
  search?: string | null,
  page?: number
}

const getEvents = async ({
  name,
  date,
  search,
  page,
} : EventType) => {
  const from = page ? page * 10 : 0;
  const to = from + (10) - 1;

  let table = 'calendar_earnings';
  if (name === 'Stock Splits') {
    table = 'calendar_stock_splits';
  }
  if (name === 'IPOs') {
    table = 'calendar_ipos';
  }
  if (name === 'Economic Events') {
    table = 'calendar_economic_events';
  }
  let req = supabase
    .from(table)
    .select('*')
    .gte('Event Date', format(startOfDay(new Date(date)), 'yyyy-MM-dd\'T\'HH:mm:ssXX'))
    .lte('Event Date', format(endOfDay(new Date(date)), 'yyyy-MM-dd\'T\'HH:mm:ssXX'))

  if (search && table === 'calendar_earnings') {
    req = req.or(
      `Symbol.ilike.%${search}%,Company.ilike.%${search}%,Event Name.ilike.%${search}%`,
    )
  }
  if (search && (table === 'calendar_stock_splits' || table === 'calendar_ipos')) {
    req = req.or(
      `Symbol.ilike.%${search}%,Company.ilike.%${search}%`,
    )
  }
  if (search && table === 'calendar_economic_events') {
    req = req.or(
      `Event.ilike.%${search}%`,
    )
  }
  const { data, error } = await req.range(from, to);

  if (error) {
    throw new Error(error.message)
  }

  return data;
}

export default function useEvents({
  name, date, search, page,
} : EventType) {
  const curDate = format(date, 'yyyy-MM-dd');
  return useQuery({
    queryKey: ['useEvents', name, curDate, search, page],
    queryFn: () => getEvents({
      name, date, search, page,
    }),
  })
}
